<template>
  <t-default-entry-sidebar
    v-if="sidebarInfo"
    :sidebar-list="sidebarInfo.sidebarList"
    :sidebar-current="sidebarInfo.sidebarCurrent"
    :heading="sidebarInfo.heading"
    :sub-heading="sidebarInfo.subHeading"
    :sidebar-heading="sidebarInfo.sidebarHeading"
    :sidebar-sub-heading="sidebarInfo.sidebarSubHeading"
    :class="componentClassName"
    :footer="false"
  >
    <form class="t-walkthrough-business-hours-guidance__form" @submit.prevent="handleSubmitForm">
      <div class="t-walkthrough-business-hours-guidance__description">
        <a-heading tag="h3" size="small">2. 営業時間外対応方法設定</a-heading>
      </div>
      <div class="t-walkthrough-business-hours-guidance__fields">
        <m-form-input label="対応方法">
          <a-select-field id="responseModeOptions" v-model="currentResponseMode" :options="responseModeOptions" />
        </m-form-input>
        <m-automatic-responder-setting
          v-model:voice="currentVoice"
          v-model:content="currentContent"
          v-model:phone-number="currentPhoneNumber"
          v-model:absence-mail="currentAbsenceMail"
          v-model:email-notification="currentEmailNotification"
          :voice-d-x-phone-number-list="voiceDXPhoneNumberList"
          :response-mode="responderResponseMode"
          :voice-list="voiceList"
          :show-email="true"
          :is-voice-playing="isVoicePlaying"
          @play="handlePlayVoice"
          @stop="handleStopVoice"
        />
      </div>
      <div class="t-walkthrough-business-hours-guidance__buttons">
        <m-button-container>
          <a-button variant="block" submit="submit" color="primary">次へ</a-button>
          <a-button variant="outlined" color="primary" @click="handleCancelClick">戻る</a-button>
          <a-button
            color="primary"
            class="t-walkthrough-business-hours-guidance__button-optional"
            @click="handleNotSettingClick"
            >初期設定はせずにホーム画面へ</a-button
          >
        </m-button-container>
      </div>
    </form>
    <!-- Info, Erro Modal -->
    <teleport to="body">
      <o-modal
        id="walkthroughBusinessGuidance_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
        </template>
      </o-modal>
    </teleport>
  </t-default-entry-sidebar>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import TDefaultEntrySidebar from '@/components/templates/default-entry-sidebar';
import AHeading from '@/components/atoms/heading';
import AButton from '@/components/atoms/button';
import ASelectField from '@/components/atoms/select-field';
import MButtonContainer from '@/components/molecules/button-container';
import MAutomaticResponderSetting from '@/components/molecules/automatic-responder-setting';
import MFormInput from '@/components/molecules/form-input';
import { cloneDeep } from 'lodash';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';

export default {
  name: 't-walkthrough-business-hours-guidance',
  components: {
    TDefaultEntrySidebar,
    AHeading,
    AButton,
    ASelectField,
    MButtonContainer,
    MAutomaticResponderSetting,
    MFormInput,
  },
  mixins: [customRequest, customValidate],
  props: {
    class: {
      type: String,
      default: '',
    },
    // sidebarInfo: {
    //   type: Object,
    //   default: null,
    // },
    // voiceList: {
    //   type: Array,
    //   default: new Array(0),
    // },
    // handlePlayVoice: {
    //   type: Function,
    //   default: () => {},
    // },
    // handleFormSubmit: {
    //   type: Function,
    //   default: () => {},
    // },
    // handleCancelClick: {
    //   type: Function,
    //   default: () => {},
    // },
    // handleNotSettingClick: {
    //   type: Function,
    //   default: () => {},
    // },
  },
  data() {
    return {
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      responseModeOptions: [
        {
          label: 'ガイダンスを流して留守電',
          value: 'voice-guidance',
        },
        {
          label: 'ガイダンスを流して切断',
          value: 'voice-guidance-no-message',
        },
        {
          label: '外線転送',
          value: 'transfer',
        },
      ],
      voiceDXPhoneNumberList: [],
      // currentResponseMode: 'voice-guidance-no-message',
      currentResponseMode: null,
      currentVoice: '',
      currentContent: '',
      outOfServiceGuidance1: null,
      outOfServiceGuidance2: null,
      currentPhoneNumber: '',
      currentAbsenceMail: '',
      currentEmailNotification: false,
      sidebarInfo: {
        sidebarList: [
          { label: 'ユーザー招待' },
          {
            label: '営業時間設定',
            subStepLabel: '営業時間設定する場合',
            steps: ['営業時間設定', '営業時間外対応方法設定', '休憩時間対応方法設定'],
            currentStep: 2,
          },
          { label: '着信フローの設定' },
        ],
        sidebarCurrent: 2,
        heading: '営業時間設定',
        subHeading: 'Step 2',
        sidebarSubHeading: 'Walk Through',
        sidebarHeading: '初期設定',
      },
      voiceList: [
        {
          value: '1',
          label: '日本語 | 女性 | 大人 | 02',
        },
      ],

      //音声
      audio: null,
      isVoicePlaying: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-walkthrough-business-hours-guidance');
      return `${baseClassName} ${this.class}`.trim();
    },
    responderResponseMode() {
      // if (this.currentResponseMode === 'voice-guidance' || this.currentResponseMode === 'voice-guidance-no-message') {
      //   return 'voice-guidance';
      // } else {
      //   if (this.voiceDXPhoneNumberList.find((v) => v.value === this.currentPhoneNumber)) {
      //     return 'voiceDX';
      //   }
      //   return 'transfer';
      // }
      return this.currentResponseMode;
    },
    dbResponseMode() {
      if (this.currentResponseMode === 'voice-guidance') {
        return 'voiceMessage';
      }
      if (this.currentResponseMode === 'voice-guidance-no-message') {
        return 'onlyGuidance';
      }
      return 'transferCall';
    },
    isGuidance() {
      return this.currentResponseMode === 'voice-guidance' || this.currentResponseMode === 'voice-guidance-no-message';
    },
  },
  watch: {
    currentResponseMode(val, oldVal) {
      if (oldVal === 'voice-guidance-no-message') {
        this.outOfServiceGuidance1 = this.currentContent;
      } else if (oldVal === 'voice-guidance') {
        this.outOfServiceGuidance2 = this.currentContent;
      }
      if (val === 'voice-guidance-no-message') {
        this.currentContent = this.outOfServiceGuidance1;
      } else if (val === 'voice-guidance') {
        this.currentContent = this.outOfServiceGuidance2;
      }
    },
    $route(to, from) {
      if (this.audio && this.audio.state === 'running') this.audio.close();
    },
  },
  created() {
    this.preloadData();
  },
  methods: {
    preloadData() {
      this.postRequest('/walkthrough/business-hours-guidance-preload-data', {
        companyID: this.companyID,
      })
        .then(res => {
          this.currentResponseMode = res.data.mode ? res.data.mode : 'voice-guidance-no-message';
          // this.currentContent = res.data.content ? res.data.content : '';
          this.outOfServiceGuidance1 = res.data.outOfServiceGuidance1;
          this.outOfServiceGuidance2 = res.data.outOfServiceGuidance2;
          this.currentAbsenceMail = res.data.absenceMail ? res.data.absenceMail : '';
          this.currentEmailNotification = res.data.emailNotification ? res.data.emailNotification : false;
          this.currentPhoneNumber = res.data.phoneNumber ? res.data.phoneNumber : '';
          this.voiceDXPhoneNumberList = res.data.voiceDXData ? res.data.voiceDXData : [];
          if (this.voiceDXPhoneNumberList.length !== 0) {
            this.responseModeOptions = [
              {
                label: 'ガイダンスを流して留守電',
                value: 'voice-guidance',
              },
              {
                label: 'ガイダンスを流して切断',
                value: 'voice-guidance-no-message',
              },
              {
                label: '外線転送',
                value: 'transfer',
              },
              {
                label: 'COTOHA Voice DX Basic',
                value: 'voiceDX',
              },
            ];
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('検索'));
        });
    },
    handleSubmitForm(e) {
      e.preventDefault();
      const payload = {
        mode: this.dbResponseMode,
      };
      // if (this.responderResponseMode === 'voice-guidance') {
      if (this.isGuidance) {
        payload.voice = this.currentVoice;
        payload.content = this.currentContent;
        payload.absenceMail = this.currentAbsenceMail;
        payload.emailNotification = this.currentEmailNotification;
      } else {
        payload.phone_number = this.currentPhoneNumber;
      }
      if (this.validateForm(payload)) {
        //COTOHA音声を作成
        const self = this;
        // if(this.responderResponseMode === 'voice-guidance' && payload.content && payload.content.trim()) {
        if (this.isGuidance && payload.content && payload.content.trim()) {
          const outOfServiceGuidance = {};
          const key =
            this.responderResponseMode === 'voice-guidance' ? 'outOfServiceGuidance2' : 'outOfServiceGuidance1';
          outOfServiceGuidance[key] = payload.content;
          this.postRequest('/cotohattsupload', { data: outOfServiceGuidance })
            .then(data => {
              if (data.status === 'success') {
                payload.outOfServiceGuidanceURL = data.data.guidanceURL[`${key}URL`];
                this.handleFormSubmit(payload);
              } else {
                self.showErrorModal(messageContent.requireTry('音声作成'));
              }
            })
            .catch(error => {
              self.showErrorModal(messageContent.requireTry('音声作成'));
            });
        } else {
          this.handleFormSubmit(payload);
        }
      }
    },
    validateForm(formData) {
      // if (this.responderResponseMode === 'voice-guidance') {
      if (this.isGuidance) {
        // Check special characters
        if (this.hasSpecialCharacterInObject(formData)) {
          this.showErrorModal(messageContent.hasSpecialCharacter);
          return false;
        }
        // Guidance is not null
        if (!formData.content) {
          this.showErrorModal(messageContent.requireInput('ガイダンス内容'));
          return false;
        }
        // Only space check
        const onlySpaceChk = this.onlySpaceCheck(formData.content, 'ガイダンス内容');
        if (!onlySpaceChk.status) {
          this.showErrorModal(onlySpaceChk.message);
          return false;
        }
        const lengthCheck = this.guidanceLengthCheck(formData.content);
        if (!lengthCheck.status) {
          this.showErrorModal(lengthCheck.message);
          return false;
        }
        const charCheck = this.guidanceCharCheck(formData.content);
        if (!charCheck.status) {
          this.showErrorModal(charCheck.message);
          return false;
        }
        // Validate email
        if (formData.emailNotification) {
          const lengthCheck = this.emailLengthCheck(formData.absenceMail);
          if (!lengthCheck.status) {
            this.showErrorModal(lengthCheck.message);
            return false;
          }
          if (!this.addressCheck(formData.absenceMail)) {
            this.showErrorModal(messageContent.alertNotCorrectFormat('メールアドレス'));
            return false;
          }
        }
      } else if (this.responderResponseMode === 'transfer') {
        // Validate phone number
        if (formData.phone_number.length !== 11 && formData.phone_number.length !== 10) {
          this.showErrorModal(messageContent.invalidDigitsNumberOfPhoneNumber);
          return false;
        }
        if (!this.numberOnly(formData.phone_number)) {
          this.showErrorModal(messageContent.phonenumberIsNotHalfWidth);
          return false;
        }
      } else {
        if (!this.voiceDXPhoneNumberList.some(v => v.value === formData.phone_number)) {
          this.showErrorModal(messageContent.requirePhonenumberOfVDXB);
          return false;
        }
      }
      return true;
    },
    handleFormSubmit(formData) {
      //console.log('営業時間設定');
      // console.log(formData);
      this.postRequest('/walkthrough/save-business-hours-guidance', { formData })
        .then(res => {
          if (res.status === 'success') {
            this.$router.push({ name: 'WTBreakTimeHoursGuidance' });
          } else {
            throw 'show error!';
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('検索'));
        });
    },
    handleCancelClick() {
      this.$router.push({ name: 'WTBusinessHoursDateTime' });
    },
    handleNotSettingClick() {
      this.updateFirstVisitFlag();
      this.$router.push({ name: 'Home' });
    },
    updateFirstVisitFlag(status = false) {
      this.postRequest('/walkthrough/update-firstVisitFlag', { status })
        .then(res => {
          if (res.status === 'success') {
            //console.log('firstVisitFlag is updated to', status);
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('検索'));
        });
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    async handlePlayVoice(data) {
      if (!data.content) {
        this.showErrorModal(messageContent.requireInput('ガイダンス内容'));
        return;
      }
      if (data.content && this.hasSpecialCharacterInObject(data.content)) {
        this.showErrorModal(messageContent.hasSpecialCharacter);
        return;
      }
      const lengthCheck = this.guidanceLengthCheck(data.content);
      if (!lengthCheck.status) {
        this.showErrorModal(lengthCheck.message);
        return;
      }
      const charCheck = this.guidanceCharCheck(data.content);
      if (!charCheck.status) {
        this.showErrorModal(charCheck.message);
        return;
      }
      if (this.audio && this.audio.state === 'running') this.audio.close();
      this.isVoicePlaying = true;
      const self = this;
      await this.postRequest('/cotohattsupload/testvoice', { content: data.content })
        .then(async data => {
          if (data.status === 'success' && data.data.voiceBufferData) {
            self.audio = null;
            self.audio = new AudioContext();
            const arr = Uint8Array.from(data.data.voiceBufferData.data);
            const audio = await self.audio.decodeAudioData(arr.buffer);
            const source = self.audio.createBufferSource();
            source.buffer = audio;
            source.connect(self.audio.destination);
            source.start(0);
            source.onended = function () {
              self.isVoicePlaying = false;
            };
          } else {
            this.isVoicePlaying = false;
            self.showErrorModal(messageContent.requireTry('再生'));
          }
        })
        .catch(error => {
          console.log(error);
          this.isVoicePlaying = false;
          self.showErrorModal(messageContent.requireTry('再生'));
        });
    },
    handleStopVoice() {
      if (this.audio && this.audio.state === 'running') {
        const self = this;
        this.audio.close().then(function () {
          self.isVoicePlaying = false;
        });
      }
    },
  },
};
</script>
